import { render, staticRenderFns } from "./IconEmojiHappyOutline.vue?vue&type=template&id=da055932"
import script from "./IconEmojiHappyOutline.vue?vue&type=script&lang=js"
export * from "./IconEmojiHappyOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports